import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useOwnerDashboard() {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({ period: "MTD", businessUnitId: "all", financialYearId: null });

  const refetch = useCallback(() => {
    setIsLoading(true);
    setError(null);
    const params = new URLSearchParams();
    if (filters.period) params.set("period", filters.period);
    if (filters.businessUnitId) params.set("businessUnitId", filters.businessUnitId);
    if (filters.financialYearId) params.set("financialYearId", filters.financialYearId);
    api.get(`/dashboard/owner?${params.toString()}`)
      .then((r) => { setData(r.data?.data || null); setIsLoading(false); })
      .catch((e) => { setError(e); setIsLoading(false); });
  }, [filters.period, filters.businessUnitId, filters.financialYearId]);

  useEffect(() => { refetch(); }, [refetch]);

  return { data, isLoading, error, filters, setFilters, refetch };
}

export function useBusinessUnits() {
  const [units, setUnits] = useState([]);
  useEffect(() => {
    api.get("/admin-settings/business-units")
      .then((r) => setUnits(Array.isArray(r.data?.data) ? r.data.data : []))
      .catch(() => setUnits([]));
  }, []);
  return units;
}
